import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bc358baa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "searchDevice"
}
const _hoisted_2 = {
  key: 1,
  class: "tableHeader"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "D - Heart Collegato", -1))

import CollapsibleItem from "@/layout/collapsible/CollapsibleItem.vue";
import { onMounted, reactive, ref } from "vue";
import { DHeartBleDevice } from "../services/DHeartBleDevice";
import { HEART_RATE_SERVICE, BATTERY_SERVICE, BATTERY_CHARACTERISTIC } from "../BleContstants";
import { pausableWatch, useBluetooth } from '@vueuse/core'


export default /*#__PURE__*/_defineComponent({
  __name: 'DHeart',
  setup(__props) {

const ckInstance = DHeartBleDevice.getInstance();
const dHeart = reactive(ckInstance);
const isSetup = ref(false);

const {
  isSupported,
  isConnected,
  device,
  requestDevice,
  server,
} = useBluetooth({
  acceptAllDevices: true,
  optionalServices: [HEART_RATE_SERVICE, BATTERY_SERVICE, BATTERY_CHARACTERISTIC],
})


const { stop } = pausableWatch(isConnected, (newIsConnected) => {
  if (!newIsConnected) {

    return
  }
  dHeart.device = device.value;

  // Attempt to get the battery levels of the device:
  dHeart.setupDevice().then(() => isSetup.value = true);

  // We only want to run this on the initial connection, as we will use an event listener to handle updates:
  stop()
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CollapsibleItem, { data: dHeart }, {
    default: _withCtx(() => [
      (!isSetup.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(requestDevice)())),
              type: "button",
              class: "px-5 py-2.5 mx-10 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white"
            }, _toDisplayString(_ctx.$t('Ricerca device')), 1)
          ]))
        : _createCommentVNode("", true),
      (isSetup.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", null, "Livello Batteria: " + _toDisplayString(dHeart.battery), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})